import React from 'react';
import styled from 'styled-components';

interface AuthFormContainerProps {
  children: React.ReactNode;
}

const FormContainer = styled.div`
  width: 100%;
  
  .ant-form-item {
    margin-bottom: 16px;
  }
  
  .ant-form-item-label {
    padding-bottom: 4px;
    
    label {
      font-family: Inter;
      font-weight: 600;
      color: #1F2937;
      font-size: 14px;
      
      &::after {
        content: ' *';
        color: #EF4444;
        font-weight: 400;
      }
    }
  }
  
  .ant-input,
  .ant-input-affix-wrapper {
    height: 44px;
    border-radius: 6px;
    border: 1px solid #D1D5DB;
    font-family: Inter;
    font-weight: 500;
    font-size: 15px;
    color: #1F2937;
    display: flex;
    align-items: center;
    
    &:focus,
    &.ant-input-affix-wrapper-focused {
      border-color: #2563EB;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }
    
    .ant-input {
      font-family: Inter;
      font-weight: 500;
      font-size: 15px;
      color: #1F2937;
      line-height: 1.5;
    }
  }
  
  .ant-input::placeholder,
  .ant-input-affix-wrapper input::placeholder {
    color: #6B7280;
    font-family: Inter;
    font-weight: 500;
  }
  
  .ant-form-item-explain-error {
    font-family: Inter;
    font-weight: 600;
    color: #EB4335;
    font-size: 12px;
  }
  
  .ant-checkbox-wrapper {
    font-family: Inter;
    font-weight: 500;
    font-size: 16px;
    color: #1F2937;
    
    .ant-checkbox {
      margin-right: 8px;
      
      .ant-checkbox-inner {
        width: 20px;
        height: 20px;
      }
    }
  }
  
  .ant-btn {
    height: 44px;
    border-radius: 6px;
    font-weight: 600;
    font-size: 16px;
    
    &.ant-btn-primary {
      background: #2563EB;
      border-color: #2563EB;
      
      &:hover {
        background: #1D4ED8;
        border-color: #1D4ED8;
      }
      
      &:disabled {
        background: #94A7CF;
        border-color: #94A7CF;
        cursor: not-allowed;
        
        &:hover {
          background: #94A7CF;
          border-color: #94A7CF;
        }
      }
    }
  }
  
  .ant-btn-default {
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    color: #2563EB;
    border-color: #2563EB;
    
    &:hover {
      color: #2563EB;
      border-color: #2563EB;
    }
  }
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 32px;
  
  h2 {
    font-family: Inter;
    font-weight: 600;
    font-size: 30px;
    color: #000000;
    margin-bottom: 8px;
  }
  
  p {
    color: #6B7280;
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .secondaryText {
    font-family: Inter !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    color: #6B7280 !important;
    margin: 0;
    line-height: 1.5;
  }
`;

const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 46px;
  margin-bottom: 28px;
  
  .forgot-password {
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    color: #2563EB;
    text-decoration: none;
    
    &:hover {
      color: #1D4ED8;
      text-decoration: underline;
    }
  }
`;

const SecurityNote = styled.div`
  text-align: center;
  margin-top: 24px;
  
  p {
    color: #6B7280;
    font-size: 12px;
    margin: 0;
  }
  
  .secondaryText {
    font-family: Inter !important;
    font-weight: 400 !important;
    color: #6B7280 !important;
    font-size: 12px !important;
    margin: 0;
  }
`;

const AuthFormContainer: React.FC<AuthFormContainerProps> = ({ children }) => {
  return <FormContainer>{children}</FormContainer>;
};

// Export các styled components để sử dụng trong các pages
export {
  AuthFormContainer as default,
  Header,
  FormActions,
  SecurityNote,
}; 